import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'shippingmethodtransportation',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `shippingmethodtransportation`,
    method: 'get',
    params: queriesParams
  })
}

export function addShippingMethodTransportation (shippingMethodTransportation) {
  return request({
    method: 'post',
    url: 'shippingmethodtransportation',
    data: shippingMethodTransportation
  })
}

export function show (id) {
  return request({
    url: `shippingmethodtransportation/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `shippingmethodtransportation/${id}`,
    method: 'patch',
    data
  })
}
